export default "__VITE_ASSET__B47I8nqb__"